import { cx } from "@/utils/cx";

const sizes = {
	xs: "size-1.5",
	sm: "size-2",
	md: "size-2.5",
	lg: "size-3",
	xl: "size-3.5",
	"2xl": "size-4",
	"3xl": "size-4.5",
	"4xl": "size-5",
};

const statusColor = {
	online: "bg-fg-success-secondary",
	warning: "bg-fg-warning-secondary",
	error: "bg-fg-error-secondary",
} as const;

export type AvatarOnlineIndicatorStatus = keyof typeof statusColor;

interface AvatarOnlineIndicatorProps {
	size: "xs" | "sm" | "md" | "lg" | "xl" | "2xl" | "3xl" | "4xl";
	status: AvatarOnlineIndicatorStatus;
	className?: string;
}

/**
 * Status dot for Avatar — online (green), warning (orange), or error (red).
 * Positioned top-left per Figma Avatar (`88:12717`).
 */
export const AvatarOnlineIndicator = ({
	size,
	status,
	className,
}: AvatarOnlineIndicatorProps) => (
	<span
		className={cx(
			"absolute top-0 left-0 rounded-full ring-[1.5px] ring-bg-primary",
			statusColor[status],
			sizes[size],
			className,
		)}
	/>
);
